export enum PROJECT_TYPES_ENUM {
    WINDOW_TAKEOFF = 'window_takeoff',
    INTERACTIVE_MARKUP = 'interactive_markup',
    INTERACTIVE_MARKUP_ONLY = 'interactive_markup_only',
}
